class PaginationModel {
    skip = 0;
    take = 0;
}
export default PaginationModel;
